module.exports = __webpack_public_path__ + "media/32.daaf2890.mp3";